import { LessonType } from "@hubcapp/types";

export const lessonTypeToDisplayString = (lessonType: LessonType | string) => {
  if (lessonType === LessonType.Dit) {
    return "DIT";
  }

  return lessonType?.replace(/([A-Z])/g, " $1")?.slice(1) || "";
};
